(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-page-reset"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.Shopify && window.Shopify.designMode) return;

    function resetPage() {
      if (!document.querySelector('[data-page-reset]')) return;

      var url = new URL(window.location.href);
      if (!url.searchParams.has('page')) return;

      url.searchParams.delete('page');
      window.location.replace(url.toString());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resetPage, { once: true });
    } else {
      resetPage();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["demo-direction-switcher"] && !Shopify.designMode) return;
  try {
    /* DEMO APPARATUS — remove with snippets/demo-direction-switcher.liquid */
  (function () {
    'use strict';

    var KNOWN = ['ref', 'hard'];
    var STORAGE_KEY = 'demo-direction';
    var root = document.querySelector('[data-demo-switcher]');
    if (!root) return;

    var segments = root.querySelectorAll('[data-demo-direction]');

    function currentDirection() {
      var dir = document.documentElement.getAttribute('data-direction');
      if (KNOWN.indexOf(dir) !== -1) return dir;
      return 'ref';
    }

    function reflect() {
      var active = currentDirection();
      for (var i = 0; i < segments.length; i++) {
        var dir = segments[i].getAttribute('data-demo-direction');
        segments[i].setAttribute('aria-pressed', dir === active ? 'true' : 'false');
      }
    }

    function applyDirection(dir) {
      if (KNOWN.indexOf(dir) === -1) return;
      document.documentElement.setAttribute('data-direction', dir);

      // Persist fallback (carries direction across internal links lacking ?dir).
      try {
        window.localStorage.setItem(STORAGE_KEY, dir);
      } catch (e) {
        /* storage may be unavailable — non-fatal for the demo */
      }

      // URL owns truth: update ?dir without a reload, preserving ?demo etc.
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('dir', dir);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* history API unavailable — direction still applied to <html> */
      }

      reflect();
    }

    function onActivate(event) {
      var dir = event.currentTarget.getAttribute('data-demo-direction');
      applyDirection(dir);
    }

    for (var i = 0; i < segments.length; i++) {
      segments[i].addEventListener('click', onActivate);
    }

    reflect();

    // --- Draggable (demo bench: move the pill off anything it overlaps) -----
    // Translate offset from the anchored bottom/inline-end position. Using a
    // transform keeps this RTL-neutral (no physical left/right) and persists
    // across internal navigation via localStorage.
    var POS_KEY = 'demo-switcher-pos';
    var handle = root.querySelector('[data-demo-drag]');
    var pos = { x: 0, y: 0 };
    try {
      var saved = JSON.parse(window.localStorage.getItem(POS_KEY) || 'null');
      if (saved && typeof saved.x === 'number' && typeof saved.y === 'number') {
        pos = saved;
      }
    } catch (e) {
      /* storage/parse may fail — start from the anchored position */
    }

    function applyPos() {
      root.style.transform = 'translate(' + pos.x + 'px,' + pos.y + 'px)';
    }

    function clampIntoView() {
      var margin = 8; // always keep at least this many px on-screen
      var r = root.getBoundingClientRect();
      var dx = 0;
      var dy = 0;
      if (r.left < margin) dx = margin - r.left;
      else if (r.right > window.innerWidth - margin) dx = (window.innerWidth - margin) - r.right;
      if (r.top < margin) dy = margin - r.top;
      else if (r.bottom > window.innerHeight - margin) dy = (window.innerHeight - margin) - r.bottom;
      if (dx || dy) {
        pos.x += dx;
        pos.y += dy;
        applyPos();
      }
    }

    function savePos() {
      try {
        window.localStorage.setItem(POS_KEY, JSON.stringify(pos));
      } catch (e) {
        /* non-fatal for the demo */
      }
    }

    if (handle) {
      applyPos();
      clampIntoView();

      var dragging = false;
      var startX = 0;
      var startY = 0;
      var baseX = 0;
      var baseY = 0;

      function onMove(event) {
        if (!dragging) return;
        pos.x = baseX + (event.clientX - startX);
        pos.y = baseY + (event.clientY - startY);
        applyPos();
        if (event.cancelable) event.preventDefault();
      }

      function onUp() {
        if (!dragging) return;
        dragging = false;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
        clampIntoView();
        savePos();
      }

      handle.addEventListener('pointerdown', function (event) {
        dragging = true;
        startX = event.clientX;
        startY = event.clientY;
        baseX = pos.x;
        baseY = pos.y;
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('pointercancel', onUp);
        if (event.cancelable) event.preventDefault();
      });

      window.addEventListener('resize', clampIntoView);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["molecule-delivery-promise"] && !Shopify.designMode) return;
  try {
    (function initDeliveryPromise() {
    var roots = document.querySelectorAll('[data-delivery-promise]');
    if (!roots.length) return;

    /* ---- Engine-powered mode: sync with header delivery promise ---- */
    function hydrateFromEngine(root, p) {
      var state = root.getAttribute('data-stock-state');
      if (state === 'out_of_stock') return;

      var dot = root.querySelector('.c-delivery-promise__dot');
      var deliveryEl = root.querySelector('.c-delivery-promise__delivery');
      var countdownEl = root.querySelector('[data-delivery-countdown]');
      var seps = root.querySelectorAll('.c-delivery-promise__sep');

      /* Update delivery text */
      if (deliveryEl) {
        var text = '';
        if (p.district && (p.type === 'same-day' || p.type === 'next-day' || p.type === 'future')) {
          text = p.label + ' to ' + p.district;
        } else if (p.type === 'no-region') {
          text = p.label;
        } else {
          text = p.label;
        }
        deliveryEl.textContent = text;
      }

      /* Update countdown */
      if (countdownEl) {
        if (p.countdown) {
          countdownEl.textContent = 'Order in ' + p.countdown;
          countdownEl.hidden = false;
          if (seps[1]) seps[1].hidden = false;
        } else {
          countdownEl.hidden = true;
          if (seps[1]) seps[1].hidden = true;
        }
      }

      /* Update dot color */
      if (dot) {
        dot.className = 'c-delivery-promise__dot';
        if (p.dotColor === 'green') {
          dot.classList.add('c-delivery-promise__dot--in-stock');
        } else if (p.dotColor === 'terracotta') {
          dot.classList.add('c-delivery-promise__dot--low-stock');
        }
        if (p.dotPulsing) dot.classList.add('c-delivery-promise__dot--pulse');
      }
    }

    /* Try to hook into the delivery engine */
    var engineConnected = false;
    if (window.CasinettoDelivery && window.CasinettoDelivery.onUpdate) {
      engineConnected = true;
      window.CasinettoDelivery.onUpdate(function(p) {
        roots.forEach(function(root) { hydrateFromEngine(root, p); });
      });
    } else {
      /* Engine loads with defer — listen for its ready event */
      document.addEventListener('delivery:ready', function() {
        if (window.CasinettoDelivery && window.CasinettoDelivery.onUpdate) {
          engineConnected = true;
          window.CasinettoDelivery.onUpdate(function(p) {
            roots.forEach(function(root) { hydrateFromEngine(root, p); });
          });
        }
      });
    }

  })();
  } catch(e) { console.error(e); }
})();

})();
